import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';
import {Route} from 'react-router-dom';

export default [
  <Route key="/business/showcase/rings" element={<ShowocaseLayout />}>
    <Route path="business/showcase/rings" element={<AsyncPage />} />
  </Route>,
];
